/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../Ihouse/layout/core'
import {DashCardOne} from '../../../Components/Cards/DashCardOne'
import axios from '../../../Helpers/Api_instance'

const DashboardWrapper = () => {
  const intl = useIntl()
  const [data, setData] = useState({
    branchesCount: 0,
    totalOrdersCount: 0,
    todaysOrdersCount: 0,
    todaysRevenue: 0,
    totalRevenue: 0,
  })

  const getDashBoardData = async () => {
    try {
      const response = await axios.get('/dashboard')
      if (response && response.data) {
        setData(response.data.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getDashBoardData()
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-4'>
        <div className='col'>
          <DashCardOne
            className='card-xl-stretch mb-xl-8'
            svgIcon='calendar'
            color='primary'
            iconColor='white'
            title={data?.branchesCount}
            description='Active Branches'
            titleColor='white'
            descriptionColor='white'
          />
        </div>
        <div className='col'>
          <DashCardOne
            className='card-xl-stretch mb-xl-8'
            svgIcon='check'
            color='warning'
            iconColor='white'
            title={data?.totalOrdersCount}
            description='Total Orders'
            titleColor='white'
            descriptionColor='white'
          />
        </div>
        <div className='col'>
          <DashCardOne
            className='card-xl-stretch mb-xl-8'
            svgIcon='handcart'
            color='danger'
            iconColor='white'
            title={data?.totalRevenue?.toFixed(2) + '£'}
            description='Total Revenue'
            titleColor='white'
            descriptionColor='white'
          />
        </div>
        <div className='col'>
          <DashCardOne
            className='card-xl-stretch mb-xl-8'
            svgIcon='dollar'
            color='success'
            iconColor='white'
            title={data?.todaysOrdersCount}
            description='Todays Orders'
            titleColor='white'
            descriptionColor='white'
          />
        </div>
        <div className='col'>
          <DashCardOne
            className='card-xl-stretch mb-xl-8'
            svgIcon='dollar'
            color='info'
            iconColor='white'
            title={data?.todaysRevenue + '£'}
            description='Todays Revenue'
            titleColor='white'
            descriptionColor='white'
          />
        </div>
      </div>
    </>
  )
}

export {DashboardWrapper}
